
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.852 3.17a.5.5 0 01.5.5v4.667a.5.5 0 11-1 0V3.671a.5.5 0 01.5-.5zm-.5 8.278a.5.5 0 01.5-.5h.007a.5.5 0 110 1h-.007a.5.5 0 01-.5-.5zm.5 2.112a6 6 0 100-12 6 6 0 000 12zm0 1a7 7 0 100-14 7 7 0 000 14z","fill":"currentColor"}})])
          )
        }
      }
    